export const skillsData = [
  "HTML",
  "CSS",
  "Javascript",
  "MongoDB",
  "React",
  "Node",
  "Git",
  "Bootstrap",
  "MaterialUI",
  "TypeScript"
];

